const parseResponse = async (response) => {
    const data = await response.json().catch(() => null);

    if (!response.ok) {
        return data ?? {
            status: 'error',
            error: response.statusText
        };
    }

    return data;
};

const blogService = {
    async random() {
        const apiURL = process.env.REACT_APP_API + '/blog/random';

        const headers = {
            'Accept': 'application/json',
            'Content-type': 'application/json'
        };

        return await fetch(apiURL, {
            method: 'GET',
            headers: headers
        })
        .then(parseResponse)
        .then((data) => {
            return data;
        })
        .catch((error) => {
            return error;
        });
    }
};

export default blogService;
